import { Button, Flex, Modal, Typography } from "antd"

import css from "./index.module.css"

const { Text, Title } = Typography

type Props = {
  cancelText: string
  isLoading: boolean
  okText: string
  onCancel: () => void
  onOk: () => void
  open: boolean
  text: React.ReactNode | string
  title: string
}
export const DeleteConfirm = ({
  cancelText,
  isLoading,
  okText,
  onCancel,
  onOk,
  open,
  text,
  title,
}: Props) => {
  return (
    <Modal closable={false} footer={null} onOk={onOk} open={open}>
      <Flex className={css.modalWrapper}>
        <Title className={css.title} level={4}>
          {title}
        </Title>
        <Flex gap={48} vertical>
          <>
            {typeof text === "string" ? (
              <Text style={{ fontSize: 16 }}>{text}</Text>
            ) : (
              text
            )}
            <Flex gap={16} justify="center">
              <Button
                htmlType="button"
                id="GENERATED_ID_DELETECONFIRM_BUTTON_VOID_1"
                onClick={onCancel}
                size="large"
              >
                {cancelText}
              </Button>
              <Button
                htmlType="button"
                id="GENERATED_ID_DELETECONFIRM_BUTTON_VOID_2"
                loading={isLoading}
                onClick={onOk}
                size="large"
                type="primary"
              >
                {okText}
              </Button>
            </Flex>
          </>
        </Flex>
      </Flex>
    </Modal>
  )
}
